import { render, staticRenderFns } from "./Layout2x1.vue?vue&type=template&id=08c821c9&scoped=true&"
import script from "./Layout2x1.vue?vue&type=script&lang=js&"
export * from "./Layout2x1.vue?vue&type=script&lang=js&"
import style0 from "./Layout2x1.vue?vue&type=style&index=0&id=08c821c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c821c9",
  null
  
)

export default component.exports